/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PortfolioFolders_portfoliosConnection$ref = any;
export type FoldersRefetchWrapper_viewer$ref = any;
export type FoldersRefetchWrapper_viewer = {
    readonly foldersPortfolios?: {
        readonly totalResults: number | null;
        readonly numberOfPages: number | null;
        readonly pageInfo: {
            readonly hasNextPage: boolean;
            readonly endCursor: string | null;
        };
        readonly edges: ReadonlyArray<{
            readonly cursor: string;
        } | null> | null;
        readonly " $fragmentRefs": PortfolioFolders_portfoliosConnection$ref;
    } | null;
    readonly " $refType": FoldersRefetchWrapper_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "FoldersRefetchWrapper_viewer",
    "type": "Viewer",
    "metadata": {
        "connection": [
            {
                "count": "first",
                "cursor": "after",
                "direction": "forward",
                "path": [
                    "foldersPortfolios"
                ]
            }
        ]
    },
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "first",
            "type": "Int"
        },
        {
            "kind": "RootArgument",
            "name": "after",
            "type": "String"
        },
        {
            "kind": "RootArgument",
            "name": "portfolioTypes",
            "type": "[PortfolioTypes]"
        },
        {
            "kind": "RootArgument",
            "name": "foldersSort",
            "type": "PortfoliosSortByTypes"
        },
        {
            "kind": "RootArgument",
            "name": "userIds",
            "type": "[String]"
        },
        {
            "kind": "RootArgument",
            "name": "page",
            "type": "Int"
        },
        {
            "kind": "RootArgument",
            "name": "hasUserId",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": "foldersPortfolios",
                    "name": "__FoldersRefetchWrapper_foldersPortfolios_connection",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "page",
                            "variableName": "page"
                        },
                        {
                            "kind": "Variable",
                            "name": "portfolioTypes",
                            "variableName": "portfolioTypes"
                        },
                        {
                            "kind": "Variable",
                            "name": "sortBy",
                            "variableName": "foldersSort"
                        },
                        {
                            "kind": "Variable",
                            "name": "userIds",
                            "variableName": "userIds"
                        }
                    ],
                    "concreteType": "PortfoliosConnection",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "totalResults",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "numberOfPages",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pageInfo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hasNextPage",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "endCursor",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PortfoliosEdge",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "cursor",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PortfolioV2",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "__typename",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "PortfolioFolders_portfoliosConnection",
                            "args": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = '2d0713460bab69cbd1b4f391fffc939e';
export default node;
